import { Component, Input, ViewChild, ElementRef } from '@angular/core';
import { DashboardService } from 'app/shared/services/dashboard/dashboard.service';
import { LoaderButton } from '../loader-button/loader-button.component';
import { CONFIG } from 'app/config/config';

@Component({
  selector: 'tog-help-tutorial',
  templateUrl: 'dashboard-help-tutorial.template.html',
  styleUrls: ['dashboard-help-tutorial.scss']
})
export class DashboardHelpTutorial {
  hoverTutorial: any;
  supportSiteUrl: string = CONFIG.SUPPORT_SITE_URL;

  @Input() adminMode: boolean = false;

  @ViewChild('helpTutorialModalButton') helpTutorialModalButton: ElementRef;
  @ViewChild('confirmHelpTutorialButton') confirmHelpTutorialButton: LoaderButton;
  @ViewChild('deleteTutorialButton') deleteTutorialButton: ElementRef;
  @ViewChild('confirmDeleteButton') confirmDeleteButton: LoaderButton;

  constructor(public dashboardService: DashboardService) {}

  addTutorial() {
    this.dashboardService.resetForm();
    this.helpTutorialModalButton.nativeElement.click();
  }

  editTutorial(tutorial: any) {
    this.dashboardService.editTutorial(tutorial);
    this.helpTutorialModalButton.nativeElement.click();
  }

  confirmSaveTutorial() {
    this.dashboardService.confirmSaveTutorial()
    .then(() => {
      this.confirmHelpTutorialButton.setConfirmed();
    })
    .catch((e) => {
      this.confirmHelpTutorialButton.setInactive();
    });
  }

  deleteTutorial(tutorial: any) {
    this.dashboardService.tutorialToDelete = tutorial;
    this.deleteTutorialButton.nativeElement.click();
  }

  confirmDelete(hideToast?: boolean) {
    this.dashboardService.confirmDeleteTutorial(hideToast)
    .then(() => {
      this.confirmDeleteButton.setConfirmed();
    })
    .catch((e) => {
      this.confirmDeleteButton.setInactive();
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/components/dashboard-help-tutorial/dashboard-help-tutorial.component.ts